import { BaseList } from "App/Screens/SubModules/Component";
import descriptor from "App/Screens/Estimation/ProductParentGroups/descriptor";

class ProductParentGroupList extends BaseList {
  constructor(props) {
    super(props)

    this.appName = 'estimation'
    this.modelName = 'productparentgroup'
    this.propsList = {
      avatar: 'name',
      pageTitle: 'Product Parent Group',
      descriptor,
      masterKey: 'module-product-productParentGroup',
      groupByOptions: [
        {
          label: 'Code',
          key: 'code',
          dataIndex: 'code',
        },
      ]
    }
  }
}

export default ProductParentGroupList